import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'

type Props = {
  onAdd: () => void
}

export const ProductsHeader = ({ onAdd }: Props) => {
  const { t } = useLocales()

  return (
    <Flex justify="flex-end">
      <Button onClick={onAdd} icon={<Add size={16} />} type="primary">
        {t('nomenclature.add_product')}
      </Button>
    </Flex>
  )
}
